import { Directive, OnInit, OnDestroy, TemplateRef, ViewContainerRef } from "@angular/core";
import { Store } from "@ngrx/store";
import { FeatureUsage } from "app/entities";
import { PlanFeatureSlugs } from "app/entities/plan-feature";
import { selectFeatureUsages } from "app/state/subscription/subscription.selectors";
import { isEqual } from "lodash";
import { Subject } from "rxjs";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";

/**
 * Exibe o conteúdo apenas quando o plano do cliente tem acesso à feature
 * "gestao-de-estoque". O acesso é concedido somente quando o valor da feature
 * for exatamente '*'; qualquer outro valor (ex.: '0') esconde o conteúdo.
 *
 * Espelha o comportamento da diretiva *canShow (estrutural, reativa ao store).
 * Os dados de feature usages são carregados pelas páginas que usam a diretiva
 * (products.component / product.component / form de produto).
 */
@Directive({
    selector: "[hasStockFeature]"
})
export class HasStockFeatureDirective implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;
    private hasView = false;

    constructor(
        private viewContainer: ViewContainerRef,
        private templateRef: TemplateRef<any>,
        private store: Store
    ) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.store.select(selectFeatureUsages)
            .pipe(
                distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(usages => {
                const enabled = this.isStockEnabled(usages);

                if (enabled && !this.hasView) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                    this.hasView = true;
                } else if (!enabled && this.hasView) {
                    this.viewContainer.clear();
                    this.hasView = false;
                }
            });
    }

    private isStockEnabled(usages: FeatureUsage[] | null | undefined): boolean {
        const usage = usages?.find(u => u.slug === PlanFeatureSlugs.GESTAO_DE_ESTOQUE);
        return usage?.limit === '*';
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
